const regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

export function countSymbols(str: string) {
    // Replace every surrogate pair with a BMP symbol,
    // and *then* get the length.
    return str.replace(regexAstralSymbols, '_').length;
}
